module.exports = __webpack_public_path__ + "img/C543.0ab0abfd.jpg";